<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>발송 등록 [{{ sendInfo.sendScnNm }}]</h1>
      </div>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본정보</h2>
      </div>
      <div class="cmdp_photo">
        <span v-if="sendInfo.imgFile === null"><img src="@/assets/img/etners-main/aiportal_img.png"></span>
        <span id="previewImage" v-show="sendInfo.imgFile !== null"></span>
        <div class="upload">
              <send-file-upload
                  ref="fileUploadRef"
                  :button-text="'물품 사진 첨부'"
                  @child="getFileData"
                  v-bind:file="[]"
              >
              </send-file-upload>
        </div>
      </div>
      <ul class="filter_list user_photo_right">
        <li>
          <dd>
            <label>No.</label>
            <ul class="w75">
              <li>
                <span v-if="sendInfo.itemId !== null"> {{ sendInfo.itemId }}</span>
                <span v-else class="forg"> 등록 시 자동 생성 </span>
              </li>
            </ul>
          </dd>
          <dd>
            <label>진행 상태</label>
            <ul class="w75">
              <li> {{sendInfo.statusNm}} </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label>용도<span class="forg">*</span></label>
            <ul class="w80">
              <li v-if="sendInfo.sendScn === '01'">
                <div v-for="item in ppsScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="ppsScnRegi1"
                      :id="`${item.cdId}_ppsScn1`"
                      @change="sendInfo.ppsScn = item.cdId"
                      :value="item.cdId"
                      :checked="item.cdId === sendInfo.ppsScn">
                  <label :for="`${item.cdId}_ppsScn1`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
                </div>
              </li>
              <li v-else>업무용</li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            &nbsp;
          </dd>
          <dd>
            <label>취급 구분</label>
            <ul class="w75">
              <li> {{ sendInfo.sendScnNm }} </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label>특송사</label>
            <ul class="w75">
              <li v-if="$route.params.sendScn === '03'">
                <div v-for="item in sendShpcScnListExpr">
                  <input
                      class="k-radio"
                      type="radio"
                      name="sendShpcScnExpr1"
                      :id="`${item.cdId}_shpcScn1`"
                      :value="item.cdId"
                      @change="sendInfo.shpcScn = item.cdId"
                      :checked="item.cdId === sendInfo.shpcScn">
                  <label :for="`${item.cdId}_shpcScn1`" class="k-radio-label" style="width:90px">{{ item.cdNm }}</label>
                </div>
              </li>
              <li v-else> {{ sendInfo.shpcScnNm }} </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label>운송장 번호<span v-if="$route.params.sendScn === '03'" class="forg">*</span></label>
            <ul>
              <li v-if="$route.params.sendScn === '02'">
                <input
                    class="w100"
                    :class="{'error' : errorTarget === 'blNo'}"
                    v-model.trim="sendInfo.blNo"
                    @input="sendInfo.blNo=EtnersCommonUtil.cutByteLength(sendInfo.blNo, 100)"
                    :placeholder="'운송장 번호 미입력 시 자동 생성됩니다.'"
                >
              </li>
              <li v-else>
                <input
                    class="w100"
                    :class="{'error' : errorTarget === 'blNo'}"
                    v-model.trim="sendInfo.blNo"
                    @input="sendInfo.blNo=EtnersCommonUtil.cutByteLength(sendInfo.blNo, 100)"
                    :placeholder="'운송장 번호를 입력하세요.'"
                >
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>임직원 정보[보내는 분]</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>사업장/거점<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <div class="box_flex">
                <kendo-dropdownlist
                    class="w50"
                    :class="{'error' : errorTarget === 'facility'}"
                    ref="facilityRef"
                    v-model="sendInfo.facility"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    :data-source="zone1DepthList"
                    @change="onChangeFacility"
                    :option-label="'사업장을 선택해주세요.'"
                    value="0"
                >
                </kendo-dropdownlist>
                 <kendo-dropdownlist
                    class="w50 mgl5"
                    :class="{'error' : errorTarget === 'area'}"
                    ref="areaRef"
                    v-model="sendInfo.area"
                    :data-source="zone2DepthList"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    @change="onChangeArea"
                    :option-label="'사업장 선택 후 선택해주세요.'"
                    value="0"
                >
                </kendo-dropdownlist>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>발신 부서<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'sendDept'}"
                       v-model.trim="sendInfo.sendDept"
                       @input="sendInfo.sendDept=EtnersCommonUtil.cutByteLength(sendInfo.sendDept, 500)"
                       @change="onChangeSend"
                       placeholder="발신 부서를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>발신<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'sendNm'}"
                       v-model.trim="sendInfo.sendNm"
                       @input="sendInfo.sendNm=EtnersCommonUtil.cutByteLength(sendInfo.sendNm, 100)"
                       placeholder="발신 정보를 입력하세요.">
              </li>
            </ul>
          </dd>
          <dd>
            <label>사원 번호<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'sendSabun'}"
                       v-model.trim="sendInfo.sendSabun"
                       @input="sendInfo.sendSabun=EtnersCommonUtil.cutByteLength(sendInfo.sendSabun, 20)"
                       placeholder="사원 번호를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>전화 번호<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'sendTel'}"
                       v-model.trim="sendInfo.sendTel"
                       @input="sendInfo.sendTel=EtnersCommonUtil.cutByteLength(sendInfo.sendTel, 20)"
                       placeholder="전화 번호를 입력하세요.">
              </li>
            </ul>
          </dd>
           <dd>
            <label>이메일</label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'sendMailAddr'}"
                       v-model.trim="sendInfo.sendMailAddr"
                       @input="sendInfo.sendMailAddr=EtnersCommonUtil.cutByteLength(sendInfo.sendMailAddr, 200)"
                       placeholder="이메일을 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>

      </ul>
      <ul class="filter_list">
        <li>
          <dd>
            <label>대리 발송</label>
            <ul class="w50">
              <li class="w100">
                <input
                    type="checkbox"
                    id="steadYn"
                    class="k-checkbox"
                    @click="sendInfo.steadYn = (sendInfo.steadYn === 'Y' ? 'N' : 'Y'); onChangeSteadYn(sendInfo.steadYn);"
                >
                <label for="steadYn" class="k-checkbox-label"><span class="mgl10">대리인 지정</span></label>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>대리 발송인<span v-show="sendInfo.steadYn==='Y'" class="forg">*</span></label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'steadNm'}"
                       v-model.trim="sendInfo.steadNm"
                       :disabled="sendInfo.steadYn === 'N'"
                       @input="sendInfo.steadNm=EtnersCommonUtil.cutByteLength(sendInfo.steadNm, 100)"
                       placeholder="대리 발송인을 입력하세요.">
              </li>
            </ul>
          </dd>
          <dd>
            <label>대리 발송인 부서<span v-show="sendInfo.steadYn==='Y'" class="forg">*</span></label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'steadDept'}"
                       v-model.trim="sendInfo.steadDept"
                       :disabled="sendInfo.steadYn === 'N'"
                       @input="sendInfo.steadDept=EtnersCommonUtil.cutByteLength(sendInfo.steadDept, 500)"
                       placeholder="대리 발송인 부서를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <!-- 상세 정보[보내시는 분] -->
    <send-upsert-regi
        v-if="$route.params.sendScn === '01'"
        ref="sendSaveDetailRef"
        :propsSendInfo="sendInfo"
        :lockerNmDataSource="lockerNmDataSource"
    ></send-upsert-regi>
    <send-upsert-deli
        v-if="$route.params.sendScn === '02'"
        ref="sendSaveDetailRef"
        :propsSendInfo="sendInfo"
        :lockerNmDataSource="lockerNmDataSource"
    ></send-upsert-deli>
    <send-upsert-expr
        v-if="$route.params.sendScn === '03'"
        ref="sendSaveDetailRef"
        :propsSendInfo="sendInfo"
        :lockerNmDataSource="lockerNmDataSource"
    ></send-upsert-expr>


    <div class="button_area w30">
      <ul>
        <li class="w25"><button class="large_btn" @click="redirectToList">목록</button></li>
        <li class="w25"><button class="large_btn orange" @click="saveSend">등록</button></li>
      </ul>
    </div>
  </section>
</template>
<script>

import ManageSendList from "@/views/web/kiosk/logistics/send/SendList.vue";

import SendFileUpload from "@/components/send/SendFileUpload.vue";
import SendUpsertRegi from "@/components/send/SendUpsertRegi";
import SendUpsertExpr from "@/components/send/SendUpsertExpr";
import SendUpsertDeli from "@/components/send/SendUpsertDeli";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";

import EtnersCommonUtil from "@/common/etners.common.util";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";

export default {
  name: "SendSave",
  components: {SendFileUpload, SendUpsertRegi, SendUpsertExpr, SendUpsertDeli},
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this
    vm.onChange1Depth('facilityRef')

    // 사업장, 거점 세팅
    vm.$refs.facilityRef.kendoWidget().value(vm.loginUserData.facility)
    vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
    vm.$refs.areaRef.kendoWidget().value(vm.loginUserData.area)
    vm.getLockerNmList(vm.loginUserData.area)
  },
  methods: {
    getLockerNmList (area) {
      const vm = this
      if(!!!area) {
        vm.lockerNmDataSource = []
        return
      }
      const param = {
        loginUserToken: vm.loginUserToken,
        area: area
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerNmList.json`
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData

        // 보관 위치 디폴트 세팅
        vm.lockerNmDataSource = resultData
        let lockerId = null
        if (resultData.length > 0) {
          lockerId = resultData[0].lockerId
        }
        vm.sendInfo.lockerId = lockerId
      })
    },
    onChangeSend () {
      const vm = this
      // if (vm.sendInfo.steadYn === "N") {
      //   const sendNm = vm.$refs.sendNmRef.kendoWidget().value()
      //   if(!!sendNm) {
      //     vm.sendInfo.steadNm = sendNm.trim()
      //   }
      //   const sendDept = vm.$refs.sendDeptRef.kendoWidget().value()
      //   if(!!sendDept) {
      //     vm.sendInfo.steadDept = sendDept.trim()
      //   }
      // }
    },
    onChangeSteadYn (steadYn) {
      const vm = this
      if (steadYn === 'Y') {
        // 발송인 정보 초기화
        vm.sendInfo.steadNm = null
        vm.sendInfo.steadDept = null
      } else {
        vm.sendInfo.steadNm = vm.sendInfo.sendNm
        vm.sendInfo.steadDept = vm.sendInfo.sendDept
      }
    },
    onChangeFacility () {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.lockerNmDataSource = []
    },
    onChangeArea () {
      const vm = this
      vm.sendInfo.area = vm.$refs.areaRef.kendoWidget().value()
      vm.getLockerNmList(vm.sendInfo.area)
    },
    getSendInfo () {
      const vm = this
      const refs = vm.$refs
      let sendInfo = vm.sendInfo

      // 사업장
      if(refs.facilityRef !== undefined && refs.facilityRef !== null) {
        sendInfo.facility = refs.facilityRef.kendoWidget().value()
      }
      // 거점
      if(refs.areaRef !== undefined && refs.areaRef !== null) {
        sendInfo.area = refs.areaRef.kendoWidget().value()
      }
      return sendInfo
    },
    getSteadInfo () {
      const vm = this
      const steadYn = vm.sendInfo.steadYn
      let steadInfo = {}

      if (steadYn === 'N') {
        steadInfo.steadNm = vm.sendInfo.sendNm
        steadInfo.steadDept = vm.sendInfo.sendDept
        steadInfo.steadTel = vm.sendInfo.sendTel
        steadInfo.steadMailAddr = vm.sendInfo.sendMailAddr
      }
      return steadInfo
    },
    saveSend () {
      const vm = this
      const sendScn = vm.$route.params.sendScn
      let sendInfo = vm.getSendInfo()

      // 유효성 체크
      if(EtnersCommonUtil.isEmpty(sendInfo.ppsScn)) {
        kendo.alert('용도를 선택해 주세요.')
        vm.errorTarget = null
        return
      }
      if(sendScn === '03' && EtnersCommonUtil.isEmpty(sendInfo.blNo)) {
        kendo.alert('운송장 번호를 입력해 주세요.')
        vm.errorTarget = 'blNo'
        return
      }
      else if (EtnersCommonUtil.isNotEmpty(sendInfo.blNo) && !EtnersCommonUtil.isBlNo(sendInfo.blNo)){
        kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
        vm.errorTarget = 'blNo'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.facility)) {
        kendo.alert('사업장을 선택해 주세요.')
        vm.errorTarget = 'facility'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.area)) {
        kendo.alert('거점을 선택해 주세요.')
        vm.errorTarget = 'area'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.sendDept)) {
        kendo.alert('발신 부서를 입력해 주세요.')
        vm.errorTarget = 'sendDept'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.sendNm)) {
        kendo.alert('발신을 입력해 주세요.')
        vm.errorTarget = 'sendNm'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.sendSabun)) {
        kendo.alert('사원 번호를 입력해 주세요.')
        vm.errorTarget = 'sendSabun'
        return
      } else if (!EtnersLogisticsUtil.isValidSabun(sendInfo.sendSabun)){
        kendo.alert('사원 번호를 형식에 맞게 입력해 주세요')
        vm.errorTarget = 'sendSabun'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.sendTel)) {
        kendo.alert('전화 번호를 입력해 주세요')
        vm.errorTarget = 'sendTel'
        return
      } else if (!EtnersLogisticsUtil.isTelNum(sendInfo.sendTel)) {
        kendo.alert('전화 번호를 형식에 맞게 입력해 주세요.')
        vm.errorTarget = 'sendTel'
        return
      }
      if (EtnersCommonUtil.isNotEmpty(sendInfo.sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(sendInfo.sendMailAddr)) {
        kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
        vm.errorTarget = 'sendMailAddr'
        return
      }
      if (sendInfo.steadYn === 'Y') {
        if(EtnersCommonUtil.isEmpty(sendInfo.steadNm)) {
          kendo.alert('발송인을 입력해 주세요.')
          vm.errorTarget = 'steadNm'
          return
        }
        if(EtnersCommonUtil.isEmpty(sendInfo.steadDept)) {
          kendo.alert('발송인 부서를 입력해 주세요.')
          vm.errorTarget = 'steadDept'
          return
        }
      }
      vm.errorTarget = null

      let newSendInfo = false
      newSendInfo = vm.$refs.sendSaveDetailRef.getPropsSendInfo()
      if(!newSendInfo) {
        return
      } else {
        sendInfo = {
          ...newSendInfo,
          sendTel: sendInfo.sendTel.replaceAll('-', ''),
        }
      }

      // if (sendInfo.steadYn === 'Y') {
      //   if (sendInfo.sendNm === sendInfo.steadNm && sendInfo.sendDept === sendInfo.steadDept
      //       && sendInfo.sendSabun === sendInfo.steadSabun && sendInfo.sendTel === sendInfo.steadTel) {
      //     kendo.alert("<p style='text-align: center;'>대리 발송이라면<br>발신 정보가 발송 정보와 달라야 합니다.</p>\n")
      //     return
      //   }
      // } else {
      //   if (sendInfo.sendNm !== sendInfo.steadNm && sendInfo.sendDept !== sendInfo.steadDept
      //       && sendInfo.sendSabun !== sendInfo.steadSabun && sendInfo.sednTel !== sendInfo.steadTel){
      //     kendo.alert("<p style='text-align: center;'>대리 발송이 아니라면<br>발신 정보가 발송 정보와 같아야 합니다.</p>\n")
      //     return
      //   }
      // }

      const saveUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendSave.json`
      const formData = new FormData()
      const params = {
        loginUserToken: vm.loginUserToken,
        sendInfo: {
          ...sendInfo,
          ...vm.getSteadInfo()
        },
      }
      if(vm.sendInfo.imgFile){
        vm.sendInfo.imgFile.forEach(function (v) {
          formData.append('file', v.rawFile)
        })
      }
      formData.append('sendSaveRequestParam', new Blob([JSON.stringify(params)],{
        type: 'application/json',
      }))

      // API 호출
      ApiUtil.postIncludeUploadFile(saveUrl, formData).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        kendo.alert('등록되었습니다.')
        vm.redirectToList()
      })
    },
    redirectToList () {
      // 목록으로 포워딩
      this.$router.push({
        name: "ManageSendList"
      })
    },
    getFileData (fileInfo) {
      const vm = this

      vm.sendInfo.imgFile = fileInfo

      // 미리보기 세팅
      setTimeout(() => {
        const raw = fileInfo[0].rawFile
        const reader = new FileReader()
        const name = fileInfo[0].name
        if (raw) {
          reader.onloadend = function () {
            document.getElementById('previewImage').innerHTML = '<img alt=' + name + ' src=' + this.result + ">"
          }

          reader.readAsDataURL(raw)
        }
      })
    },
  },
  data () {
    const loginUserData = JSON.parse(sessionStorage.getItem("loginUserData"))

    // 등기, 택배, 해외특송
    let sendScnNm, sendScn, shpcScnNm, shpcScn
    switch (this.$route.params.sendScn) {
      case '01':
        sendScnNm = '등기'
        sendScn = '01'
        shpcScnNm = '우체국'
        shpcScn = '05'
        break
      case '02':
        sendScnNm = '택배'
        sendScn = '02'
        shpcScnNm = '일양택배'
        shpcScn = '04'
        break
      case '03':
        sendScnNm = '해외특송'
        sendScn = '03'
        shpcScnNm = 'DHL'
        shpcScn = '01'
        break
    }

    return {
      EtnersCommonUtil: EtnersCommonUtil,
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: loginUserData,

      sendInfo: {
        sendScnNm: sendScnNm,
        sendScn: sendScn,
        shpcScnNm: shpcScnNm,
        shpcScn: shpcScn,

        ppsScn: "02", // 용도
        blNo: null,
        imgFile: null,
        sendId: null,
        sendSn: null, // No.
        itemId: null, // 물품 코드
        statusNm: '물품 접수',
        status: '02',

        facility: loginUserData.facility,
        area: loginUserData.area,

        sendNm: null, // 발신
        sendDept: null,
        sendSabun: null,
        sendTel: null,
        sendMailAddr: null,

        receiveNm: null,
        receiveTel: null,
        receiveAddr: null,
        receiveAddrDtl: null,
        receivePost: null,
        contents: null, //비고
        deliveryScn: "02", // 발송 수단
        contentsScn: "01", // 내용물
        contentsScnDesc: null,
        cost: null,
        lockerId: null,
        lockerCellId: null,
        regCost: null,
        woodenYn: 'N',
        qty: '1',
        itemNm: '',

        steadYn: "N",
        steadNm: null,
        steadDept: null,
        steadSabun: null,
        steadTel: null,
      },

      lockerNmDataSource: [],
      addrData : {}, // 주소 검색 컴포넌트 용
      errorTarget: null, // 유효성 체크 error 클래스 활용
    }
  }
}
</script>

<style scoped>

</style>
